var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"compreSportsMeet_scheduleDetail_dataBattleReport"}},[(_vm.dataBattleReportInfor && !_vm.dataBattleReportInfor.isHasData)?_c('NOT_DATA',{attrs:{"className":'relativePtb30'}}):_vm._e(),(
      _vm.dataBattleReportInfor &&
      _vm.dataBattleReportInfor.isHasData &&
      _vm.dataBattleReportInfor.dataArr
    )?[_c('div',{staticClass:"dataBattleReport_infor"},_vm._l((_vm.dataBattleReportInfor.dataArr),function(textItem,textIndex){return _c('p',{key:textIndex,staticClass:"textItem",domProps:{"textContent":_vm._s(textItem)}})}),0)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }